/* PWW v56 mobile dropdown fix + cache-busted asset.
   Enables tap/click dropdown menus on touch/mobile where hover is not available. */
(function () {
  function closePwwDropdowns(except) {
    document.querySelectorAll('.pww-nav-dropdown.is-open').forEach(function (item) {
      if (except && item === except) return;
      item.classList.remove('is-open');
      var trigger = item.querySelector('.pww-nav-trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function initPwwMobileDropdowns() {
    var nav = document.querySelector('.pww-nav');
    if (!nav || nav.dataset.pwwDropdownsReady === 'true') return;
    nav.dataset.pwwDropdownsReady = 'true';

    nav.querySelectorAll('.pww-nav-dropdown').forEach(function (item) {
      var trigger = item.querySelector('.pww-nav-trigger');
      var menu = item.querySelector('.pww-dropdown-menu');
      if (!trigger || !menu) return;

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var willOpen = !item.classList.contains('is-open');
        closePwwDropdowns(item);
        item.classList.toggle('is-open', willOpen);
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });

      menu.addEventListener('click', function (event) {
        if (event.target && event.target.closest('a')) {
          closePwwDropdowns();
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('.pww-nav-dropdown')) closePwwDropdowns();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closePwwDropdowns();
    });

    window.addEventListener('resize', function () {
      if (window.matchMedia('(min-width: 991px)').matches) closePwwDropdowns();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPwwMobileDropdowns);
  } else {
    initPwwMobileDropdowns();
  }
})();

/* PWW v80: Featured wheels carousel controls */
(function () {
  function initPwwFeaturedCarousel() {
    document.querySelectorAll('[data-pww-featured-carousel]').forEach(function (carousel) {
      if (carousel.dataset.pwwCarouselReady === 'true') return;
      carousel.dataset.pwwCarouselReady = 'true';
      var track = carousel.querySelector('[data-pww-carousel-track]');
      var prev = carousel.querySelector('[data-pww-carousel-prev]');
      var next = carousel.querySelector('[data-pww-carousel-next]');
      if (!track || !prev || !next) return;
      function amount() {
        var card = track.querySelector('.pww-featured-wheel-card');
        return card ? Math.max(card.getBoundingClientRect().width + 16, track.clientWidth * 0.75) : track.clientWidth * 0.8;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -amount(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: amount(), behavior: 'smooth' }); });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPwwFeaturedCarousel);
  } else {
    initPwwFeaturedCarousel();
  }
})();


/* v85: preserve vehicle context after vehicle finder links, add quick size switching, and reduce customer thinking. */
(function(){
  function ready(fn){ if(document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function getParam(name){ return new URLSearchParams(window.location.search).get(name) || ''; }
  function escapeHtml(v){ return String(v || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  ready(function(){
    var vehicle = getParam('pww_vehicle');
    var shop = getParam('pww_shop');
    var size = getParam('pww_size');
    var wheelSizes = getParam('pww_wheel_sizes');
    var tireSizes = getParam('pww_tire_sizes');
    if (!vehicle) return;
    var title = document.querySelector('.collection-hero__title, h1.title--primary, main h1');
    if (title) {
      var type = shop === 'tires' ? 'Tires' : 'Rims';
      title.textContent = type + ' for your ' + vehicle;
    }
    var searchBox = document.querySelector('[data-pww-collection-search]');
    if (searchBox) {
      searchBox.hidden = true;
      searchBox.setAttribute('aria-hidden', 'true');
      searchBox.classList.add('pww-collection-search--vehicle-hidden');
    }
    if (searchBox && !document.querySelector('.pww-vehicle-context-strip')) {
      var strip = document.createElement('div');
      strip.className = 'pww-vehicle-context-strip page-width pww-vehicle-context-strip--' + (shop || 'products');
      var sizeText = size ? '<strong>' + escapeHtml(size.replace(/\binch\b/i, 'inch')) + '</strong>' : '';
      function preserveVehicleParams(url, type, clean) {
        try {
          var current = new URL(window.location.href);
          var target = new URL(url, window.location.origin);
          ['pww_vehicle','pww_wheel_sizes','pww_tire_sizes','pww_vehicle_bolt'].forEach(function(key){
            var value = current.searchParams.get(key);
            if (value) target.searchParams.set(key, value);
          });
          target.searchParams.set('pww_shop', type);
          target.searchParams.set('pww_size', type === 'tires' ? clean : clean + ' inch');
          target.searchParams.set('sort_by', 'price-ascending');
          current.searchParams.getAll('filter.p.m.custom.wheel_bolt_pattern').forEach(function(value){
            if (type === 'wheels') target.searchParams.append('filter.p.m.custom.wheel_bolt_pattern', value);
          });
          return target.pathname + '?' + target.searchParams.toString();
        } catch(e) { return url; }
      }
      function buildChips(raw, type) {
        if (!raw) return '';
        var items = raw.split('|').map(function(v){ return v.trim(); }).filter(Boolean);
        if (!items.length) return '';
        var current = String(size || '').toLowerCase();
        var label = type === 'tires' ? 'Compatible tire sizes:' : 'Compatible rim sizes:';
        return '<div class="pww-context-size-chips"><span>' + label + '</span>' + items.map(function(item){
          var clean = item.replace(/\s+OEM$/i, '');
          var display = type === 'tires' ? item : (clean + '\"' + (/OEM$/i.test(item) ? ' OEM' : ''));
          var active = current && current.indexOf(clean.toLowerCase()) !== -1;
          var href = '#';
          if (type === 'tires') {
            var m = clean.match(/^(\d{3})\/(\d{2})R(\d{2})$/i);
            if (m) href = preserveVehicleParams('/collections/' + m[3] + '-tire?filter.p.m.custom.tire_width=' + encodeURIComponent(m[1]) + '&filter.p.m.custom.tire_aspect_ratio=' + encodeURIComponent(m[2]), type, clean);
          } else {
            href = preserveVehicleParams('/collections/' + clean.replace(/[^0-9.]/g, '') + '-wheel', type, clean);
          }
          return '<a class="pww-context-size-chip' + (active ? ' is-active' : '') + '" href="' + href + '">' + escapeHtml(display) + '</a>';
        }).join('') + '</div>';
      }
      var chips = shop === 'tires' ? buildChips(tireSizes, 'tires') : buildChips(wheelSizes, 'wheels');
      strip.innerHTML = '<div class="pww-context-summary"><span>Vehicle selected</span><strong>' + escapeHtml(vehicle) + '</strong>' + (sizeText ? '<em>Starting point: ' + sizeText + '</em>' : '') + '<small>Products are already filtered. Use extra filters only if needed.</small><a class="pww-context-back" href="/?pww_restore_vehicle=1">Back to vehicle size choices</a></div>' + chips;
      searchBox.parentNode.insertBefore(strip, searchBox);
    }
  });
})();


/* PWW v87: final polish helpers */
(function(){
  function ready(fn){ if(document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function normalizeBolt(value){ return String(value || '').toLowerCase().replace(/\s+/g,'').replace(/x/g,'x').replace(/mm/g,''); }
  ready(function(){
    // On vehicle-aware wheel pages, clearly show the hard vehicle bolt target for testing/support.
    var params = new URLSearchParams(window.location.search);
    var vehicleBolt = params.get('pww_vehicle_bolt');
    var strip = document.querySelector('.pww-vehicle-context-strip');
    if (strip && vehicleBolt && !strip.querySelector('.pww-context-bolt-note')) {
      var note = document.createElement('small');
      note.className = 'pww-context-bolt-note';
      note.textContent = 'Rim fitment filter: ' + vehicleBolt + ' bolt pattern.';
      var summary = strip.querySelector('.pww-context-summary') || strip;
      summary.appendChild(note);
    }

    // Hard front-end safety net: hide wheel cards that visibly show a different single bolt pattern.
    if (vehicleBolt && params.get('pww_shop') === 'wheels') {
      var target = normalizeBolt(vehicleBolt);
      document.querySelectorAll('.product-card-wrapper, .card-wrapper').forEach(function(card){
        var specText = card.querySelector('.pww-card-specs') ? card.querySelector('.pww-card-specs').innerText : '';
        var titleText = card.querySelector('.card__heading, .full-unstyled-link') ? card.querySelector('.card__heading, .full-unstyled-link').innerText : '';
        var text = specText || titleText || '';
        var matches = text.match(/\b\d+x\d+(?:\.\d+)?(?:\s*\/\s*\d*x\d+(?:\.\d+)?)*\b/ig);
        if (matches && matches.length) {
          var compatible = matches.some(function(m){ return normalizeBolt(m).indexOf(target) !== -1; });
          if (!compatible) {
            var li = card.closest('li.grid__item') || card;
            li.style.display = 'none';
            li.setAttribute('data-pww-hidden-incompatible-bolt','true');
          }
        }
      });
    }

    // In House Specials: put wheel filters ahead of tire filters so the mostly-wheel page feels cleaner.
    var isLocalSpecials = /\/collections\/(local|in-house|in-house-specials)/i.test(window.location.pathname) || /In Store Clear Out Specials|In-House Specials/i.test(document.body.innerText || '');
    if (isLocalSpecials) {
      var wheelFirst = ['Wheel Diameter','Wheel Width','Wheel Bolt Pattern','Wheel Bore','Wheel Offset'];
      document.querySelectorAll('.facets__wrapper, .facets-container, facet-filters-form form, .facets').forEach(function(container){
        wheelFirst.slice().reverse().forEach(function(label){
          Array.from(container.children).forEach(function(child){
            if ((child.innerText || '').trim().indexOf(label) === 0) container.insertBefore(child, container.firstElementChild);
          });
        });
      });
    }
  });
})();

/* PWW v88: production blockers - strict vehicle context and product-page cleanup. */
(function () {
  function ready(fn){ if(document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function esc(v){ return String(v || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function params(){ return new URLSearchParams(window.location.search); }
  function normBolt(v){ return String(v || '').toLowerCase().replace(/\s+/g,'').replace(/mm\b/g,''); }
  function pathDiameter(kind){
    var re = kind === 'tires' ? /\/collections\/(\d+)-tire/i : /\/collections\/(\d+)-wheel/i;
    var m = window.location.pathname.match(re);
    return m ? m[1] : '';
  }
  function savedVehicle(){
    try { return JSON.parse(sessionStorage.getItem('pww_last_vehicle_fitment') || 'null'); } catch(e) { return null; }
  }
  function vehicleLabel(item){ return item ? (item.label || [item.year, item.make, item.model].filter(Boolean).join(' ')) : ''; }
  function wheelSizeList(item){
    if (!item || !item.wheelSizes) return '';
    var out = [];
    (item.wheelSizes || []).forEach(function(size){
      var m = String(size || '').match(/^(\d{2})/);
      if (m && out.indexOf(m[1]) === -1) out.push(m[1]);
    });
    var oem = String(item.oemSetup || (item.wheelSizes && item.wheelSizes[0]) || '').match(/^(\d{2})/);
    var oemDia = oem ? oem[1] : out[0];
    return out.map(function(d){ return d + (d === oemDia ? ' OEM' : ''); }).join('|');
  }
  function tireSizeList(item){ return item && item.tireSizes ? item.tireSizes.join('|') : ''; }
  function inferredContext(){
    var p = params();
    var shop = p.get('pww_shop') || '';
    var vehicle = p.get('pww_vehicle') || '';
    var size = p.get('pww_size') || '';
    var wheelSizes = p.get('pww_wheel_sizes') || '';
    var tireSizes = p.get('pww_tire_sizes') || '';
    var bolt = p.get('pww_vehicle_bolt') || '';
    var item = savedVehicle();

    if (!shop) {
      if (/\/collections\/\d+-tire/i.test(window.location.pathname)) shop = 'tires';
      if (/\/collections\/\d+-wheel/i.test(window.location.pathname)) shop = 'wheels';
    }

    if (item) {
      if (!vehicle) vehicle = vehicleLabel(item);
      if (!wheelSizes) wheelSizes = wheelSizeList(item);
      if (!tireSizes) tireSizes = tireSizeList(item);
      if (!bolt && item.bolt) bolt = String(item.bolt).replace(/mm$/i, '');
    }

    if (!size && shop === 'tires') {
      var tw = p.get('filter.p.m.custom.tire_width') || '';
      var ta = p.get('filter.p.m.custom.tire_aspect_ratio') || '';
      var td = pathDiameter('tires');
      var candidate = tw && ta && td ? (tw + '/' + ta + 'R' + td) : '';
      if (candidate && (!item || !item.tireSizes || item.tireSizes.indexOf(candidate) !== -1)) size = candidate;
    }
    if (!size && shop === 'wheels') {
      var wd = pathDiameter('wheels');
      if (wd) size = wd + ' inch';
    }
    return { vehicle: vehicle, shop: shop, size: size, wheelSizes: wheelSizes, tireSizes: tireSizes, bolt: bolt };
  }
  function contextUrl(url, type, clean, ctx){
    var target = new URL(url, window.location.origin);
    if (ctx.vehicle) target.searchParams.set('pww_vehicle', ctx.vehicle);
    target.searchParams.set('pww_shop', type);
    target.searchParams.set('pww_size', type === 'tires' ? clean : clean + ' inch');
    if (ctx.wheelSizes) target.searchParams.set('pww_wheel_sizes', ctx.wheelSizes);
    if (ctx.tireSizes) target.searchParams.set('pww_tire_sizes', ctx.tireSizes);
    if (ctx.bolt) target.searchParams.set('pww_vehicle_bolt', ctx.bolt);
    target.searchParams.set('sort_by', 'price-ascending');
    return target.pathname + '?' + target.searchParams.toString();
  }
  function buildChips(raw, type, ctx){
    if (!raw) return '';
    var items = raw.split('|').map(function(v){ return v.trim(); }).filter(Boolean);
    if (!items.length) return '';
    var current = String(ctx.size || '').toLowerCase();
    var label = type === 'tires' ? 'Compatible tire sizes:' : 'Compatible rim sizes:';
    return '<div class="pww-context-size-chips"><span>' + label + '</span>' + items.map(function(item){
      var clean = item.replace(/\s+OEM$/i, '');
      var display = type === 'tires' ? item : (clean + '"' + (/OEM$/i.test(item) ? ' OEM' : ''));
      var href = '#';
      if (type === 'tires') {
        var m = clean.match(/^(\d{3})\/(\d{2})R(\d{2})$/i);
        if (m) href = contextUrl('/collections/' + m[3] + '-tire?filter.p.m.custom.tire_width=' + encodeURIComponent(m[1]) + '&filter.p.m.custom.tire_aspect_ratio=' + encodeURIComponent(m[2]), type, clean, ctx);
      } else {
        href = contextUrl('/collections/' + clean.replace(/[^0-9.]/g, '') + '-wheel', type, clean, ctx);
      }
      var active = current && current.indexOf(clean.toLowerCase()) !== -1;
      return '<a class="pww-context-size-chip' + (active ? ' is-active' : '') + '" href="' + href + '">' + esc(display) + '</a>';
    }).join('') + '</div>';
  }
  function ensureVehicleStrip(){
    var ctx = inferredContext();
    if (!ctx.vehicle || (ctx.shop !== 'wheels' && ctx.shop !== 'tires')) return;
    var title = document.querySelector('.collection-hero__title, h1.title--primary, main h1');
    if (title) title.textContent = (ctx.shop === 'tires' ? 'Tires' : 'Rims') + ' for your ' + ctx.vehicle;
    var searchBox = document.querySelector('[data-pww-collection-search]');
    if (searchBox) {
      searchBox.hidden = true;
      searchBox.setAttribute('aria-hidden', 'true');
      searchBox.classList.add('pww-collection-search--vehicle-hidden');
    }
    if (document.querySelector('.pww-vehicle-context-strip')) return;
    var insertBefore = searchBox || document.querySelector('.facets-wrapper, .facets-container, #ProductGridContainer, .collection') || document.querySelector('main');
    if (!insertBefore || !insertBefore.parentNode) return;
    var strip = document.createElement('div');
    strip.className = 'pww-vehicle-context-strip page-width pww-vehicle-context-strip--' + ctx.shop;
    var chips = ctx.shop === 'tires' ? buildChips(ctx.tireSizes, 'tires', ctx) : buildChips(ctx.wheelSizes, 'wheels', ctx);
    var boltNote = (ctx.shop === 'wheels' && ctx.bolt) ? '<small class="pww-context-bolt-note">Rim fitment filter: ' + esc(ctx.bolt) + ' bolt pattern.</small>' : '';
    strip.innerHTML = '<div class="pww-context-summary"><span>Vehicle selected</span><strong>' + esc(ctx.vehicle) + '</strong>' + (ctx.size ? '<em>Starting point: <strong>' + esc(ctx.size) + '</strong></em>' : '') + '<small>Products are already filtered. Use extra filters only if needed.</small><a class="pww-context-back" href="/?pww_restore_vehicle=1">Back to vehicle size choices</a>' + boltNote + '</div>' + chips;
    insertBefore.parentNode.insertBefore(strip, insertBefore);
  }
  function boltSegments(value){
    var m = String(value || '').match(/\b(?:4|5|6|8|10)\s*x\s*\d{3}(?:\.\d+)?(?:\s*(?:\/|,)\s*(?:4|5|6|8|10)\s*x\s*\d{3}(?:\.\d+)?)*\s*(?:mm)?\b/ig);
    return (m || []).join('/').split(/[\/,]/).map(normBolt).filter(Boolean);
  }
  function cardBoltText(item){
    return [
      item.dataset && item.dataset.pwwProductTitle,
      item.innerText
    ].filter(Boolean).join(' ');
  }
  function hideIncompatibleWheelCards(){
    var ctx = inferredContext();
    if (ctx.shop !== 'wheels' || !ctx.bolt) return;
    var target = normBolt(ctx.bolt);
    document.querySelectorAll('#product-grid > .grid__item, .product-grid > .grid__item').forEach(function(item){
      var bolts = boltSegments(cardBoltText(item));
      if (!bolts.length) return;
      var ok = bolts.some(function(b){ return b === target; });
      if (!ok) {
        item.hidden = true;
        item.style.display = 'none';
        item.setAttribute('data-pww-hidden-incompatible-bolt', 'true');
      } else if (item.getAttribute('data-pww-hidden-incompatible-bolt') === 'true') {
        item.hidden = false;
        item.style.display = '';
        item.removeAttribute('data-pww-hidden-incompatible-bolt');
      }
    });
  }
  function cleanupProductDescriptionSpecs(){
    var specsCard = document.querySelector('.pww-product-specs-card');
    var details = document.querySelector('.pww-product-description-under-media');
    if (!specsCard || !details || details.dataset.pwwSpecsCleaned === 'true') return;
    var labels = /^(brand|model|finish|size|wheel size|bolt pattern|offset|center bore|centre bore|bore|load rating|rim diameter|tire width|aspect ratio|load index|speed rating)\s*:/i;
    details.querySelectorAll('li').forEach(function(li){
      if (labels.test((li.textContent || '').trim())) li.remove();
    });
    details.querySelectorAll('ul,ol').forEach(function(list){
      if (!(list.textContent || '').trim()) list.remove();
    });
    details.dataset.pwwSpecsCleaned = 'true';
  }
  function runAll(){ ensureVehicleStrip(); hideIncompatibleWheelCards(); cleanupProductDescriptionSpecs(); }
  ready(function(){
    runAll();
    setTimeout(runAll, 250);
    setTimeout(runAll, 1000);
    document.addEventListener('facet:updated', function(){ setTimeout(runAll, 100); setTimeout(runAll, 600); });
    var grid = document.getElementById('product-grid') || document.body;
    var obs = new MutationObserver(function(){ window.requestAnimationFrame(runAll); });
    obs.observe(grid, { childList: true, subtree: true });
  });
})();


/* PWW v89: brand grid safeguards and vehicle wheel visual de-duplication. */
(function () {
  function ready(fn){ if(document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function params(){ return new URLSearchParams(window.location.search); }
  function norm(v){ return String(v || '').toLowerCase().replace(/&amp;/g,'&').replace(/[^a-z0-9.]+/g,' ').replace(/\s+/g,' ').trim(); }
  function isVehicleWheelPage(){
    var p = params();
    return p.get('pww_shop') === 'wheels' && !!p.get('pww_vehicle');
  }
  function cardTitle(item){
    return item.getAttribute('data-pww-product-title') || ((item.querySelector('.card__heading a, .full-unstyled-link') || {}).textContent || '');
  }
  function imageKey(item){
    var src = item.getAttribute('data-pww-product-image-src') || '';
    if (!src) {
      var img = item.querySelector('.card__media img');
      src = img ? (img.currentSrc || img.src || '') : '';
    }
    return String(src || '').split('?')[0].replace(/_(?:\d+x|small|medium|large|master)\./i,'.').toLowerCase();
  }
  function wheelFamilyKey(item){
    var title = norm(cardTitle(item));
    var size = (title.match(/\b\d{2}\s*x\s*\d+(?:\.\d+)?\b/) || [''])[0].replace(/\s+/g,'');
    if (!size) return '';
    var base = title
      .replace(/\b(?:4|5|6|8|10)\s*x\s*\d{3}(?:\.\d+)?(?:\s*(?:\/|,)\s*(?:4|5|6|8|10)\s*x\s*\d{3}(?:\.\d+)?)*\s*(?:mm)?\b/g, ' ')
      .replace(/\b(?:et|offset)\s*[-+]?\d+\b/g, ' ')
      .replace(/\b[-+]?\d{1,3}\s*(?:mm)?\s*(?:offset|et)\b/g, ' ')
      .replace(/\b(?:cb|hub|bore|center bore|centre bore)\s*[:/-]?\s*\d+(?:\.\d+)?\s*(?:mm)?\b/g, ' ')
      .replace(/\b\d+(?:\.\d+)?\s*(?:mm)?\s*(?:cb|hub|bore|center bore|centre bore)\b/g, ' ')
      .replace(/\b\d+(?:\.\d+)?\s*mm\b/g, ' ')
      .replace(/\b(?:wheel|wheels|rim|rims|sale|cad)\b/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    var img = imageKey(item);
    return [base, size, img].filter(Boolean).join('|');
  }
  function deDupeVehicleWheels(){
    if (!isVehicleWheelPage()) return;
    var seen = {};
    var counts = {};
    var firsts = {};
    var items = Array.prototype.slice.call(document.querySelectorAll('#product-grid > .grid__item, .product-grid > .grid__item'));
    items.forEach(function(item){
      if (item.hidden || item.style.display === 'none') return;
      var key = wheelFamilyKey(item);
      if (!key) return;
      counts[key] = (counts[key] || 0) + 1;
      if (!seen[key]) { seen[key] = true; firsts[key] = item; return; }
      item.hidden = true;
      item.style.display = 'none';
      item.setAttribute('data-pww-hidden-duplicate-wheel-family','true');
    });
    Object.keys(firsts).forEach(function(key){
      var count = counts[key] || 0;
      if (count < 2) return;
      var first = firsts[key];
      if (first.querySelector('.pww-fitment-group-note, .pww-v89-variant-note')) return;
      var info = first.querySelector('.card-information') || first.querySelector('.card__information');
      if (!info) return;
      var note = document.createElement('div');
      note.className = 'pww-fitment-group-note pww-v89-variant-note';
      note.innerHTML = '<span>' + count + ' fitment variants available</span>';
      info.appendChild(note);
    });
  }
  function hideTiresOnBrandSearch(){
    var p = params();
    if (p.get('pww_brand_wheels') !== '1') return;
    document.querySelectorAll('#product-grid > .grid__item, .product-grid > .grid__item').forEach(function(item){
      var text = norm([item.getAttribute('data-pww-product-type'), item.getAttribute('data-pww-product-title'), item.textContent].filter(Boolean).join(' '));
      var looksTire = /\b(tire|tires)\b/.test(text) || /\b\d{3}\s*\/\s*\d{2}\s*r\s*\d{2}\b/.test(text);
      var looksWheel = /\b(wheel|wheels|rim|rims)\b/.test(text) || /\b\d{2}\s*x\s*\d+(?:\.\d+)?\b/.test(text);
      if (looksTire && !looksWheel) {
        item.hidden = true;
        item.style.display = 'none';
        item.setAttribute('data-pww-hidden-brand-non-wheel','true');
      }
    });
  }
  function run(){ hideTiresOnBrandSearch(); deDupeVehicleWheels(); }
  ready(function(){
    run();
    setTimeout(run, 250);
    setTimeout(run, 1000);
    document.addEventListener('facet:updated', function(){ setTimeout(run, 100); setTimeout(run, 600); });
    var root = document.getElementById('ProductGridContainer') || document.getElementById('product-grid') || document.body;
    new MutationObserver(function(){ window.requestAnimationFrame(run); }).observe(root, { childList: true, subtree: true });
  });
})();

/* PWW v90: restore vehicle wheel grouping and fill grid to 8 unique cards. */
(function () {
  function ready(fn){ if(document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function params(){ return new URLSearchParams(window.location.search); }
  function norm(v){ return String(v || '').toLowerCase().replace(/&amp;/g,'&').replace(/[^a-z0-9.]+/g,' ').replace(/\s+/g,' ').trim(); }
  function isVehicleWheelPage(){ var p = params(); return p.get('pww_shop') === 'wheels' && !!p.get('pww_vehicle'); }
  function grid(){ return document.getElementById('product-grid') || document.querySelector('.product-grid'); }
  function cardTitle(item){ return item.getAttribute('data-pww-product-title') || ((item.querySelector('.card__heading a, .full-unstyled-link') || {}).textContent || ''); }
  function cardText(item){ return [item.getAttribute('data-pww-product-title'), item.textContent].filter(Boolean).join(' '); }
  function targetBolt(){ return norm((params().get('pww_vehicle_bolt') || '').replace(/mm$/i,'')); }
  function boltSegments(text){
    var clean = String(text || '').toUpperCase().replace(/×/g,'X').replace(/\s+/g,'');
    var matches = clean.match(/(?:4|5|6|8|10)X\d{3}(?:\.\d+)?/g) || [];
    return matches.map(function(v){ return norm(v); });
  }
  function isCompatible(item){
    var bolt = targetBolt();
    if (!bolt) return true;
    var bolts = boltSegments(cardText(item));
    if (!bolts.length) return true;
    return bolts.indexOf(bolt) !== -1;
  }
  function wheelFamilyKey(item){
    var title = norm(cardTitle(item));
    var sizeMatch = title.match(/\b\d{2}\s*x\s*\d+(?:\.\d+)?\b/);
    if (!sizeMatch) return '';
    var size = sizeMatch[0].replace(/\s+/g,'');
    var base = title
      .replace(/\b(?:4|5|6|8|10)\s*x\s*\d{3}(?:\.\d+)?(?:\s*(?:\/|,)\s*(?:4|5|6|8|10)\s*x\s*\d{3}(?:\.\d+)?)*\s*(?:mm)?\b/g, ' ')
      .replace(/\b(?:et|offset)\s*[-+]?\d+\b/g, ' ')
      .replace(/\b[-+]?\d{1,3}\s*(?:mm)?\s*(?:offset|et)\b/g, ' ')
      .replace(/\b(?:cb|hub|bore|center bore|centre bore)\s*[:\/-]?\s*\d+(?:\.\d+)?\s*(?:mm)?\b/g, ' ')
      .replace(/\b\d+(?:\.\d+)?\s*(?:mm)?\s*(?:cb|hub|bore|center bore|centre bore)\b/g, ' ')
      .replace(/\b\d+(?:\.\d+)?\s*mm\b/g, ' ')
      .replace(/\b(?:wheel|wheels|rim|rims|sale|cad|projectwheelworks|project wheel works)\b/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    return [base, size].filter(Boolean).join('|');
  }
  function isV90Hidden(item){ return item.getAttribute('data-pww-v90-family-hidden') === 'true' || item.getAttribute('data-pww-hidden-duplicate-wheel-family') === 'true'; }
  function hideItem(item, reason){ item.hidden = true; item.style.display = 'none'; item.setAttribute(reason || 'data-pww-v90-family-hidden','true'); }
  function showItem(item){
    if (item.getAttribute('data-pww-v90-family-hidden') === 'true') return;
    if (item.getAttribute('data-pww-hidden-duplicate-wheel-family') === 'true') return;
    if (item.getAttribute('data-pww-hidden-incompatible-bolt') === 'true') return;
    item.hidden = false; item.style.display = '';
  }
  function visibleUniqueCount(g){
    return Array.prototype.slice.call(g.querySelectorAll(':scope > .grid__item')).filter(function(item){
      return !item.hidden && item.style.display !== 'none' && !isV90Hidden(item);
    }).length;
  }
  function applyGrouping(){
    if (!isVehicleWheelPage()) return { visible: 0, seen: {} };
    var g = grid(); if (!g) return { visible: 0, seen: {} };
    var seen = {}, counts = {}, firsts = {};
    Array.prototype.slice.call(g.querySelectorAll(':scope > .grid__item')).forEach(function(item){
      item.classList.remove('pww-v90-appended-hidden');
      var key = wheelFamilyKey(item);
      if (!isCompatible(item)) { hideItem(item, 'data-pww-hidden-incompatible-bolt'); return; }
      if (!key) { showItem(item); return; }
      counts[key] = (counts[key] || 0) + 1;
      if (!seen[key]) { seen[key] = true; firsts[key] = item; item.removeAttribute('data-pww-v90-family-hidden'); if (item.getAttribute('data-pww-hidden-duplicate-wheel-family') !== 'true') showItem(item); return; }
      hideItem(item, 'data-pww-v90-family-hidden');
    });
    Object.keys(firsts).forEach(function(key){
      var count = counts[key] || 0;
      var first = firsts[key];
      if (count < 2 || first.querySelector('.pww-v90-variant-note, .pww-fitment-group-note')) return;
      var info = first.querySelector('.card-information') || first.querySelector('.card__information');
      if (!info) return;
      var note = document.createElement('div');
      note.className = 'pww-fitment-group-note pww-v90-variant-note';
      note.innerHTML = '<span>' + count + ' fitment variants available</span>';
      info.appendChild(note);
    });
    return { visible: visibleUniqueCount(g), seen: seen };
  }
  function currentPage(){ var p = parseInt(params().get('page') || '1', 10); return isNaN(p) || p < 1 ? 1 : p; }
  function pageUrl(page){ var u = new URL(window.location.href); u.searchParams.set('page', String(page)); return u.toString(); }
  function appendCardsFromHtml(html){
    var g = grid(); if (!g) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var remoteGrid = doc.getElementById('product-grid') || doc.querySelector('.product-grid');
    if (!remoteGrid) return false;
    var added = 0;
    Array.prototype.slice.call(remoteGrid.querySelectorAll(':scope > .grid__item')).forEach(function(item){
      var handle = item.getAttribute('data-pww-product-handle') || '';
      var title = item.getAttribute('data-pww-product-title') || '';
      if (handle && g.querySelector('[data-pww-product-handle="' + CSS.escape(handle) + '"]')) return;
      var clone = item.cloneNode(true);
      clone.setAttribute('data-pww-v90-appended','true');
      clone.style.setProperty('--animation-order', String(g.children.length + 1));
      g.appendChild(clone);
      added += 1;
    });
    return added > 0;
  }
  function fillToEight(){
    if (!isVehicleWheelPage()) return;
    var g = grid(); if (!g || g.getAttribute('data-pww-v90-fill-running') === 'true') return;
    var state = applyGrouping();
    if (state.visible >= 8) return;
    g.setAttribute('data-pww-v90-fill-running','true');
    var basePage = currentPage();
    var next = basePage + 1;
    var max = basePage + 6;
    function step(){
      var latest = applyGrouping();
      if (latest.visible >= 8 || next > max) { g.removeAttribute('data-pww-v90-fill-running'); return; }
      fetch(pageUrl(next), { credentials: 'same-origin' })
        .then(function(r){ return r.ok ? r.text() : ''; })
        .then(function(html){
          next += 1;
          if (html) appendCardsFromHtml(html);
          applyGrouping();
          step();
        })
        .catch(function(){ g.removeAttribute('data-pww-v90-fill-running'); });
    }
    step();
  }
  function run(){ applyGrouping(); fillToEight(); }
  ready(function(){
    run(); setTimeout(run, 300); setTimeout(run, 1200);
    document.addEventListener('facet:updated', function(){ setTimeout(run, 150); setTimeout(run, 800); });
    var root = document.getElementById('ProductGridContainer') || grid() || document.body;
    new MutationObserver(function(){ window.requestAnimationFrame(run); }).observe(root, { childList: true, subtree: true });
  });
})();
